import dayjs from "dayjs";
import classnames from "classnames";
import { Paper, Typography } from "@mui/material";

import { useScrollIntoView } from "../../../hooks/useScrollIntoView";
import { useBoxStyles } from "../commonStyles/boxStyles";
import { useDaySelectorStyles } from "./useDaySelectorStyles";

export const DaySelector = ({ day, selected, selectDay }) => {
    const boxClasses = useBoxStyles();
    const classes = useDaySelectorStyles();

    const ref = useScrollIntoView(selected);
    const date = dayjs(day),
        weekday = date.format("ddd"),
        dayOfMonth = date.format("D"),
        month = date.format("MMM");

    return (
        <Paper ref={ref} variant="outlined" className={classnames(boxClasses.box, classes.box, { selected })} onClick={selectDay}>
            <Typography variant="body2" color="textSecondary">{weekday}</Typography>
            <Typography variant="h7" component="p">{dayOfMonth}</Typography>
            <Typography variant="label2" className={classes.month}>{month}</Typography>
        </Paper>
    );
};
